import React from 'react'
import { observer } from 'mobx-react-lite'
import { MDBBtn, MDBIcon } from 'mdb-react-ui-kit'
import Store from './../PushNotifications.store'
import { getOsUnblockSteps } from './../pushCopy'

import './PushSelfTest.component.scss'

/**
 * "Did you see that?" — the only detector we can build for OS-level suppression.
 *
 * If macOS or Windows is blocking the browser, `Notification.permission` still
 * reports "granted" and `showNotification()` resolves without error. Nothing is
 * displayed and nothing throws, so the agent believes they are covered when they
 * are not. Asking is the entire detection strategy.
 *
 * Renders nothing unless a test is awaiting an answer or has just failed.
 */
const PushSelfTest = () => {
  if (Store.selfTest === 'idle' || Store.selfTest === 'passed') return null

  if (Store.selfTest === 'failed') {
    return (
      <div id='PushSelfTestComponent' className='is-failed' role='alert'>
        <p className='pst-lead'>
          <MDBIcon icon='exclamation-triangle' /> Notifications are on for USABG, but your device is not showing them.
        </p>
        <p className='pst-body'>This is a setting on your computer or phone rather than in USABG:</p>
        <ol>
          {getOsUnblockSteps(Store.platform).map((step, i) => (
            <li key={`pst-os-${i}`}>{step}</li>
          ))}
        </ol>
        <div className='pst-actions'>
          <MDBBtn color='indigo' size='sm' onClick={() => Store.runSelfTest()}>
            Test Again
          </MDBBtn>
          <button type='button' className='pst-dismiss' onClick={() => Store.dismissSelfTest()}>
            Close
          </button>
        </div>
      </div>
    )
  }

  return (
    <div id='PushSelfTestComponent' className='is-pending' role='status'>
      <p className='pst-lead'>
        <MDBIcon icon='bell' /> We just sent a test notification.
      </p>
      <p className='pst-body'>Did it appear on your screen?</p>
      <div className='pst-actions'>
        <MDBBtn color='indigo' size='sm' onClick={() => Store.confirmSelfTest(true)}>
          Yes, I saw it
        </MDBBtn>
        <MDBBtn outline color='indigo' size='sm' onClick={() => Store.confirmSelfTest(false)}>
          No, nothing appeared
        </MDBBtn>
      </div>
    </div>
  )
}

export default observer(PushSelfTest)
